import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoOwnerState {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  dateOfBirth: string;
  email: string;
  ssn: string;
  address: string;
  city: string;
  state: string;
  zip: string;
}

const initialState: CoOwnerState = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  dateOfBirth: '',
  email: '',
  ssn: '',
  address: '',
  city: '',
  state: '',
  zip: '',
};

const coOwnerInfo = createSlice({
  name: 'coOwnerInfo',
  initialState,
  reducers: {
    setCoOwner: (state: CoOwnerState, { payload }: PayloadAction<Partial<CoOwnerState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setCoOwner } = coOwnerInfo.actions;

export default coOwnerInfo.reducer;
